import { render, staticRenderFns } from "./CoachAthleteReport.vue?vue&type=template&id=7de95c84&"
import script from "./CoachAthleteReport.vue?vue&type=script&lang=ts&"
export * from "./CoachAthleteReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports